import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { ConsentLink } from '../../components/ConsentLink';

const TERMS_URL = 'https://withjoy.com/eula';
const PRIVACY_POLICY_URL = 'https://privacy.withjoy.com';

/**
 * The SMS and email consent on the registration contact step, as the last line of the form.
 * "By continuing" lets it sit in the form rather than next to the button it names. The opt-out
 * instructions live in the linked terms and the first text, which carrier guidance allows.
 *
 * The copy is waiting for legal sign-off before it ships to guests.
 */
export const RegistrationConsent: React.FC = () => {
  const { tq } = useTranslation('eventFormDisplay');

  return (
    <TextV2
      typographyVariant="label2"
      lineHeight={1.54}
      textAlign="center"
      width="100%"
      maxWidth={['none', null, '340px']}
      marginX="auto"
      marginTop={6}
      style={{ textWrap: 'balance' } as React.CSSProperties}
    >
      {/* The sentence is quieter than the links, which keep the full text colour. */}
      <span style={{ opacity: 0.72 }}>{tq`By continuing, you agree to get event texts and emails. Msg & data rates may apply.`}</span>{' '}
      <ConsentLink href={TERMS_URL}>{tq`Terms`}</ConsentLink> {/* Translated on its own, since the links around it can't sit inside one string. */}
      <span style={{ opacity: 0.72 }}>{tq`&`}</span> <ConsentLink href={PRIVACY_POLICY_URL}>{tq`Privacy`}</ConsentLink>
    </TextV2>
  );
};
